import { OptionType } from '../../../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { Gender } from '../../../../api/useLongevityAnalysisQuery';

export const defaultGender = 'Unisex';

export const genderOptions: OptionType<Gender>[] = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: defaultGender, label: defaultGender },
];
